"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const bridge_1 = require("@completeanatomy/bridge");
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const TitleMobile_1 = require("../TitleMobile");
const organisms_1 = require("../../organisms");
const analytics_1 = require("@completeanatomy/analytics");
const utils_1 = require("../../utils");
const noop_1 = __importDefault(require("lodash/noop"));
const PLAY_BUTTON_HEIGHT = 20;
const SNACKBAR_NAME = 'OfflineAudio';
const MAX_FONT_SIZE = 26;
function Title(props) {
    const { isMobile } = (0, device_1.usePlatform)();
    const isOffline = (0, device_1.useIsDeviceOffline)();
    const { register, unregister, show } = (0, ui_1.useSnackbar)();
    const placeholderRef = (0, react_1.useRef)(null);
    const titleContainer = (0, react_1.useRef)(null);
    const titleText = (0, react_1.useRef)(null);
    const [buttonStyle, setButtonStyle] = (0, react_1.useState)({ top: 0, left: 0 });
    const [updatedFontSize, setFontSize] = (0, react_1.useState)(24);
    const bridge = (0, bridge_1.useBridge)();
    const analytics = (0, analytics_1.useAnalytics)();
    (0, react_1.useEffect)(() => {
        register(SNACKBAR_NAME, organisms_1.AudioOfflineSnackbar);
        return () => {
            unregister(SNACKBAR_NAME);
        };
    }, [register, unregister]);
    /**
     * @todo place play button to end of title, find way to use only css
     */
    const onPlay = () => {
        if (isOffline) {
            show(SNACKBAR_NAME);
            return;
        }
        bridge === null || bridge === void 0 ? void 0 : bridge.playSelectedInfoBoxObjectAudio();
        analytics.log('InfoBoxAudioPlayed');
    };
    const calculateButtonPosition = (0, react_1.useCallback)(() => {
        if (placeholderRef === null || placeholderRef === void 0 ? void 0 : placeholderRef.current) {
            const rect = placeholderRef.current.getBoundingClientRect();
            const top = placeholderRef.current.offsetTop + (rect.height - PLAY_BUTTON_HEIGHT);
            setButtonStyle({ top, left: placeholderRef.current.offsetLeft });
        }
    }, []);
    const updateFontSize = (0, react_1.useCallback)((size) => {
        const fontSize = (0, utils_1.calculateFontSize)(size, titleText.current, titleContainer.current);
        if (fontSize !== undefined &&
            size !== fontSize &&
            fontSize <= MAX_FONT_SIZE) {
            setFontSize(fontSize);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        requestAnimationFrame(calculateButtonPosition);
        updateFontSize(updatedFontSize);
    }, [props.title, calculateButtonPosition, updatedFontSize, updateFontSize]);
    if (isMobile) {
        return (0, jsx_runtime_1.jsx)(TitleMobile_1.TitleMobile, Object.assign({}, props, { "data-e2e": 'Title_TitleMobile' }));
    }
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'Title_Container', children: [(0, jsx_runtime_1.jsx)(TitleContainer, { fontSize: updatedFontSize, ref: titleContainer, "data-e2e": 'Title_TitleContainer', children: (0, jsx_runtime_1.jsxs)(TitleContainerInner, { ref: titleText, "data-e2e": 'Title_TitleContainerInner', children: [props.title, props.withAudio && ((0, jsx_runtime_1.jsx)(ButtonPlaceholder, { ref: placeholderRef, "data-e2e": 'Title_ButtonPlaceholder', children: "0000" })), props.withAudio && ((0, jsx_runtime_1.jsx)(PlayButton, { style: buttonStyle, "$playing": !!props.playing, "$faded": isOffline, onClick: onPlay, "aria-pressed": props.playing, "data-e2e": 'Title_PlayButton', children: (0, jsx_runtime_1.jsx)(PlayIcon, { name: ui_1.Icons.Sound, selected: props.playing, "data-e2e": 'Title_PlayIcon' }) }))] }) }), props.altTitle && (0, jsx_runtime_1.jsx)(AltTitle, { "data-e2e": 'Title_AltTitle', children: props.altTitle }), props.withAltNames && ((0, jsx_runtime_1.jsx)(AltNamesButton, { onClick: props.onToggleNames || noop_1.default, "data-e2e": 'Title_AltNamesButton', children: "..." }))] }));
}
exports.Title = Title;
const Container = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;

  box-sizing: border-box;

  min-width: 130px;
  min-height: 72px;

  padding: 0 18px 0 4px;

  user-select: none;
`;
const TitleContainer = styled_components_1.default.div `
  position: relative;

  max-height: 120px;

  padding: 0 0 4px;

  font-weight: bold;
  font-size: ${({ fontSize }) => fontSize}px;
`;
const AltTitle = styled_components_1.default.div `
  font-size: 12px;

  user-select: text;
`;
const AltNamesButton = (0, styled_components_1.default)(ui_1.FlatButton) `
  width: 36px;

  margin: 0;
  padding: 0;

  font-size: 20px;

  text-align: left;
`;
const PlayButton = (0, styled_components_1.default)(ui_1.FlatButton) `
  position: absolute;

  width: 30px;
  height: 20px;

  margin: 0 0 0 10px;
  padding: 0;

  color: ${({ $playing, theme }) => $playing ? theme.text : theme.textSecondary};

  opacity: ${({ $faded }) => ($faded ? 0.3 : 1)};
`;
const PlayIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 30px;
  height: 20px;
`;
const ButtonPlaceholder = styled_components_1.default.span `
  min-width: 50px;

  opacity: 0;
`;
const TitleContainerInner = styled_components_1.default.div `
  display: inline;
  flex-grow: 1;

  user-select: text;
`;
